import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { firestore } from '../Firebase/utils'


export default function ConfirmDeleteUser(props) {
    const { onClose, selectedValue, open } = props

  const deleteUser = (documentID) => {
    alert(`user with ID ${documentID} deleted`)
    firestore.collection('users').doc(documentID).delete()
  }

  const handleDeleteClose = () => {
    deleteUser(selectedValue.id) 
    
    onClose()
  };

  const handleClose = () => {
    onClose()
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Delete user ${selectedValue.data().displayName ? selectedValue.data().displayName : selectedValue.data().firstName + ' ' + selectedValue.data().lastName}?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Permanently Delete ${selectedValue.data().displayName ? selectedValue.data().displayName : selectedValue.data().firstName + ' ' + selectedValue.data().lastName}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose}>Delete</Button>
          <Button onClick={handleClose} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}